import CustomModal from "_shared/components/Modal/Modal"
import { useState } from "react"
import Button from "_shared/components/Button/Button";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { API } from "aws-amplify";

export const BullseyeAlertsModal = ({ }) => {
    const queryClient = useQueryClient();
    const { data: alerts } = useQuery({
        queryKey: ["bullseyeAlerts"],
        queryFn: async () =>
            (
                await API.graphql({
                    query: `{ panel(where: {name: {_eq: "Bullseye AI Trade Ideas"}}) { alerts } }`,
                })
            )?.data?.panel?.[0]?.alerts,
        refetchInterval: 600000,
    });

    const [open, setOpen] = useState(false);
    const [recentlyDeleted, setRecentlyDeleted] = useState([]);
    return (
        <>
            <div style={{ marginLeft: 4, marginBottom: 2 }}>Manage</div>
            <div
                onClick={() => { setOpen(!open) }}
                style={{
                    fontWeight: 100,
                    color: "#bbb8b8",
                    display: "inline",
                    border: "1px solid #ccc",
                    borderRadius: 10,
                    padding: "2px 4px",
                    marginRight: -8,
                    marginLeft: -4,
                }}
            >
                {`Alerts`}
            </div>
            <CustomModal open={open} onClose={() => setOpen(false)}>
                <div style={{ maxWidth: 350, width: 350 }}>
                    <div style={{ marginLeft: 3, marginTop: -12, fontSize: 16 }}><i className={"fas fa-bell"} /> Manage Bullseye Alerts</div>
                    <div style={{ marginTop: 15, marginBottom: 15 }}>
                        {alerts?.map(({ ticker, timestamp }) => {
                            const currentDate = new Date();
                            currentDate.setDate(currentDate.getDate() - 5);
                            const timestampDate = new Date(timestamp);
                            const oneDay = 24 * 60 * 60 * 1000;
                            const diffDays = Math.round((timestampDate.getTime() - currentDate.getTime()) / oneDay);

                            if (diffDays <= 0) {
                                return null;
                            }
                            else {
                                return <div
                                    style={{
                                        cursor: "pointer",
                                        marginTop: 5,
                                        marginBottom: 5,
                                        filter: recentlyDeleted.includes(ticker) ? "grayscale(1)" : '',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                    }}
                                    onClick={async () => {
                                        if (alerts.includes(ticker)) {
                                            setRecentlyDeleted([...recentlyDeleted, ticker]);
                                        }
                                        else {
                                            setRecentlyDeleted([]);
                                        }
                                        await API.graphql({
                                            query: `mutation($alerts: jsonb) {
                                            update_panel(where: {name: {_eq: "Bullseye AI Trade Ideas"}}, _set: {alerts: $alerts}) { 
                                                affected_rows 
                                            } 
                                        }`,
                                            variables: {
                                                alerts: alerts.map(obj => obj.ticker).includes(ticker) ? alerts.filter(obj => obj.ticker !== ticker) : [...alerts, { ticker, timestamp: new Date() }]
                                            }
                                        });
                                        await queryClient.refetchQueries(["bullseyeAlerts"]);
                                    }}
                                >
                                    <span>🚨 {ticker} {diffDays < 5 && <span style={{ color: '#aaa' }}>Expiring in {diffDays} day{diffDays !== 1 ? 's' : ''}</span>}</span>
                                    <span>🗑️Delete</span>
                                </div>
                            }
                        })}
                        {alerts?.length === 0 && <div>
                            <p>You currently have no alerts set.</p>
                            <p>Please click the red alert icon to the left of tickers to turn alerts on or off.</p>
                        </div>}
                    </div>
                    <Button
                        variant="secondary"
                        onClick={() => { setOpen(false) }}
                        fullWidth
                    >
                        Close
                    </Button>
                </div>
            </CustomModal>
        </>)
}